import { BulbOutlined, ExportOutlined } from '@ant-design/icons';
import { Flex, Grid, Typography, theme } from 'antd';
import { config } from '@/config';
import { mixpanelTrack, RevenueDashboardWidget } from '@/utils';
import { MIXPANEL_EVENT } from '@/utils/mixpanelUtils/events';

export const ConnectProfilesMessageEcho = ({
  networkId,
  showId,
}: {
  networkId: string;
  showId: string;
}) => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();

  const handleClickLink = () => {
    mixpanelTrack(MIXPANEL_EVENT.audience.socialProfiles.connectMarketplaceProfilesClicked, {
      widget: RevenueDashboardWidget.SocialProfiles,
      page: 'audience',
    });
  };

  return (
    <Flex
      align="flex-start"
      justify="center"
      gap={token.marginXS}
      style={{
        width: screens.lg ? 430 : '100%',
        justifySelf: 'flex-end',
        padding: token.paddingLG,
        background: `linear-gradient(90deg, ${token.colorWarningBg}, ${token.colorWarningBgHover})`,
      }}
    >
      <BulbOutlined style={{ marginTop: token.marginXXS, fontSize: token.fontSizeLG }} />
      <Flex vertical>
        <Typography.Text strong style={{ fontSize: token.fontSizeSM }}>
          Data for your audio, video and socials in one place
        </Typography.Text>
        <Typography.Paragraph
          style={{
            margin: 0,
            marginBottom: token.margin,
            color: token.colorTextSecondary,
            fontSize: token.fontSizeSM,
          }}
        >
          Connect your show's accounts to your marketplace profile for cross-channel insights.
        </Typography.Paragraph>
        <Typography.Link
          href={`${config.cmsUrl}/networks/${networkId}/shows/${showId}/marketplace`}
          target="_blank"
          rel="noreferrer"
          onClick={handleClickLink}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: token.marginXS,
            fontSize: token.fontSizeSM,
            fontWeight: token.fontWeightStrong,
          }}
        >
          Add YouTube, Instagram and TikTok
          <ExportOutlined />
        </Typography.Link>
      </Flex>
    </Flex>
  );
};
